import { useCallback } from "react";
import countries, { LocaleData } from "i18n-iso-countries";

import de from "i18n-iso-countries/langs/de.json";
import en from "i18n-iso-countries/langs/en.json";
import fr from "i18n-iso-countries/langs/fr.json";
import it from "i18n-iso-countries/langs/it.json";
import nl from "i18n-iso-countries/langs/nl.json";

const localeMap = {
	de,
	en,
	fr,
	it,
	nl,
} as const satisfies Record<string, LocaleData>;

const SUPPORTED_LANGUAGES = Object.keys(localeMap);

SUPPORTED_LANGUAGES.forEach(lang => {
	countries.registerLocale(localeMap[lang as keyof typeof localeMap]);
});

interface UseI18nIsoCountriesHook {
	getCountryName: (countryCode: string, languageCode: string, fallback: (countryCode: string) => string) => string;
}

export const useI18nIsoCountries = (): UseI18nIsoCountriesHook => {
	const getCountryName = useCallback(
		(countryCode: string, languageCode: string, fallback: (countryCode: string) => string): string => {
			if (SUPPORTED_LANGUAGES.includes(languageCode)) {
				return countries.getName(countryCode, languageCode) ?? fallback(countryCode);
			}

			return fallback(countryCode);
		},
		[],
	);

	return {
		getCountryName,
	};
};
